import { useEffect, useState } from "react"
import {  postSlider, patchSlider, getSliderById } from "../../services/SlidersService"
import { SlidersFormContext } from "./SlidersContext"
import { useNavigate, useParams } from 'react-router-dom';
//import { Sliders } from '../../routes/RoutesConstants'

export const SlidersFormState = ({ children }) => {
    const [report, setReport] = useState({})
    const navigate = useNavigate();
    const { id } = useParams()

    useEffect(() => {
        if (id) getSliderByIdData(id)
    }, [])

    const getSliderByIdData = async (id) => {
        let res = await getSliderById(id)
        if (res) setReport(res)
    }

    const postSliderData = async (body) => {
        const res = await postSlider(body)
        if (res) navigate("/sliders");
    }

    const patchSliderData = async (id, body) => {
        const res = await patchSlider(id, body)

        if (res) navigate("/sliders");
    }


    return <SlidersFormContext.Provider value={{
        report,
        postSliderData,
        patchSliderData,
        getSliderByIdData
    }} >
        {children}
    </SlidersFormContext.Provider>
}